export default {
    SPECIFICATION: 'Designa din egen produkt',
    FRONT_VIEW: 'Sett inifrån',
    OUTSIDE_VIEW: 'Sett utifrån',
    CLICK_TO_EDIT: 'Klicka på bilderna för att göra dina val',
    EDIT: 'REDIGERA',
    OK: 'OK',
    SELECTED_COLOR: 'VALD KUlÖR',
    NAME: 'Namn',
    RENOLIT: 'Renolit',
    COLOR_PALETTE: 'Kulörkarta',
    SEARCH: 'Sök',
    ART_NR: 'Art-nr',
    RAL: 'RAL',
    PRICE: 'Pris',
    ORNAMENT: 'Ornament',
    SELECT_GLASS_SUBHEADER: 'Välj glas för varje sida av glaskassett',
    SELECT_GLASS_SUBHEADER_INFO: 'Viktig information till dig som ska ha helglasade lösningar! Glas som går under 60cm från gångbar yta ska vara av personsäkerhetsglas. Detta innebär härdat eller laminerat glas. Denna regel gäller både invändigt och utvändigt.',
    MULLIONS_N_DIVIDERS: 'Spröjs & Mittpost',
    MULLIONS: 'Mittpost',
    MUNTINS: 'Spröjs',
    HORIZONTAL: 'Liggande',
    VERTICAL: 'Stående',
    SIZE: 'Bredd',
    INSIDE_COLOR: 'Invändig kulör',
    OUTSIDE_COLOR: 'Utvändig kulör',
    GLAZING: 'Glaskassett',
    GLASS: 'Glas',
    HANDLES: 'Handtag',
    ACTIVE_SASH_SIDE: 'Hängning',
    FIXED_SASHES_OPTIONS: 'Fast-i-Fast',
    HINGE_SIDE: 'Hängning',
    SEAL_COLOR: 'Tätningslist kulör',
    ACCESSORIES: 'Tillval',
    ACCESSORY: 'Tillval',
    UNITS: 'dm/mm',
    UNITS_ROOF_WINDOW: 'Modul/millimeter',
    BOTTOM_PANEL: 'Bröstning',
    QUANTITY: 'Antal',
    PER_ITEM: 'Per enhet',
    VAT: 'Inkl.moms',
    ADD_TO_CART: 'LÄGG I KUNDVAGN',
    SAVE_CHANGES: 'Spara dina ändringar',
    RESET_COLOR: 'Återställ kulör',
    CHANGE_SERIES: 'Ändra serien',
    WIDTH: 'Bredd',
    HEIGHT: 'Höjd',
    NONE_SELECTED: 'Ingen vald',
    ORDINARY_PRICE: 'Riktpris',
    PACKET: 'Utrustningspaket',
    SAVING: 'Du sparar',
    INITIAL: 'Ingar',
    WHY_PACKET: 'VARFÖR SKA DU VÄLJA DETTA PAKETET?',
    VALUE: 'Värde',
    SAVE_MONEY: 'Välj utrustningspaket och spara pengar',
    HINGE_TYPE: 'Beslag',
    CHOOSE_BEST_SOLUTION: 'Välj vilken lösning som passar bäst',
    WINDOW_TILT_HINGE_SIDE: 'Hängning',
    NO_PRICE: 'NO PRIS',
    DIMENSIONS_ERROR: '*Angivna dimensioner går inte att välja, vänligen försök med andra dimensioner eller vänligen kontakta oss på 0431-37 14 00*',
    BLINDS_ERROR: 'Blinds pricelist is out of range',
    APRIS: 'À-pris',
    CLASSIC: 'Inget utrustningspaket valt',
    DEFAULT_PACKET: 'Inga extra tillval',
    MULTI_PACKETS: 'MULTI PACKETS',
    MULLIONS_NOTE_WINDOWDOOR_RESTRICTION: 'Då bredden överstiger 1000mm måste man ha en horizontal mittpost för produktens hållfasthet. Kontakta oss om du önskar offert med annan spröjslösning.',
    MULLIONS_NOTE_PART_1: 'Obs!',
    MULLIONS_NOTE_PART_2: 'Har du önskemål på placeringen av dina spröjs kan du kontakta oss',
    MULLIONS_NOTE_PART_3: 'här',
    MULLIONS_NOTE_PART_4: 'så hjälper vi dig',
    DIMENSION_INFO_HEADER: 'Beskrivning av dimensioner',
    DIMENSION_INFO_HEADER_MODAL: 'Förklaring av dimensioner',
    DIMENSION_INFO: 'Nedan finner ni instruktioner om olika konstruktioner och former av dessa. Det går bra att sätta värdet ”0” för att uppnå rätt konstruktion.',
    CASEMENT_INFO_BUTTON: 'Jag förstår och vill gå vidare',
    CASEMENT_INFO_HEADER_MODAL: 'Observera!',
    CASEMENT_INFO: 'Produkten kan enbart tillverkas med tilt-funktion och utan sidohängning. Handtaget är placerat i ovankant enligt bild nedan. Önskar ni handtag på sidan kan man enkelt ändra det under HANDTAG i konfiguratorn.',
    NEXT_STEP: 'Nästa',
    PREV_STEP: 'Tidigare',
    SPROJS_LINE: 'Linjera spröjs',
    SPROJS_LINE_DESCRIPTION: 'Välj att linjera spröjsen med ett annat fönster. Är du osäker kontakta säljare',
    SPROJS_LINE_PLACEHOLDER: 'Linjera inte',
    POSITION: 'Position:',
    TOTAL_PRICE: 'Total summa',
    RESET: 'Ångra tillval',
    MIRROR_REFLECTION: 'Gångdörr',
    INNER_VIEW: 'Sett inifrån',
    OUTER_VIEW: 'Sett utifrån',
    EMPTY: '',
    NOT_CHANGED: 'Inte förändrad',
    COLORS: 'Färger',
    PREDEFINED_COLOR_MATCH: 'Renolit kombinationer',
    CUSTOM_COLOR_MATCH: 'Valfri RAL kulör',
    DOOR_STANDARD_COLOR: 'Standardfärger',
    DOOR_HANDLES: 'Handtag',
    HANDLE_COLOR: 'Handtag Kulör',
    HANDLE_OPTIONS: 'Handtag val',
    DOOR_APPEARANCE: 'Kulörer',
    DELIVERY_PRICE_INFO: 'Frakt inom Sverige från',
    DELIVERY_PRICE_LINK: '/betalnings-och-leveransvillkor#PostCodeModule',
    FREE_DELIVERY_INFO: 'Free frakt',
    DISCOUNT: 'Rabatt',
    YOU_SAVE: 'Du sparar',
    BUILD_YOUR_OWN_WINDOW: 'Välj vilken profil du önskar',
    COLOR: 'Kulör',
    APPEARANCE: 'Utseende',
    CONFIGURATOR: 'Bygg ditt eget fönster',
    CONFIGURATOR_HELP_INFO: 'Välj kategori och underkategori för att bytta ditt fönster så som du vill ha det produkt',
    BTN_GO_TO_CONFIGURATOR_DEFAULT: 'Konfigurera din fönster - Klicka här!',
    BTN_GO_TO_CONFIGURATOR_WINDOW: 'Konfigurera ditt fönster - Klicka här!',
    BTN_GO_TO_CONFIGURATOR_WINDOW_DOOR: 'Konfigurera din fönsterdörr - Klicka här!',
    BTN_GO_TO_CONFIGURATOR_FOLDING_DOOR: 'Konfigurera din vikdörr - Klicka här!',
    BTN_GO_TO_CONFIGURATOR_SLIDING_DOOR: 'Konfigurera din skjutdörr - Klicka här!',
    BTN_GO_TO_CONFIGURATOR_DOOR: 'Konfigurera din ytterdörr - Klicka här!',
    BTN_GO_TO_CONFIGURATOR_ROOF_WINDOW: 'Konfigurera ditt takfönster - Klicka här!',
    PACKETS: 'UTRUSTNINGSPAKET',
    SERIES: 'Serier',
    PACKET_SELECTED: 'Some accessories are enabled in package. If you want to remove them, change package.',
    DIMENSION_DM: 'Måtten anges i modul (hela decimeter) med ett ställ mått på 20mm för isolering. Det betyder att ett fönster som är tex 10x12 får karmyttermått 980x1180mm.',
    DIMENSION_MM_WIDTH: 'Ange de exakta karmyttermåtten i millimeter utan avdrag. Minimiumbredd: {{min}}mm. Maxbredd: {{max}}mm',
    DIMENSION_MM_HEIGHT: 'Minimiumhöjd: {{min}}mm. Maxhöjd: {{max}}mm',
    HANDLES_SIDE: 'Handtagets position',
    LEFT: 'Vänster',
    RIGHT: 'Höger',
    TOP: 'Överkant',
    INISDE_GLASS: 'Invändigt glas',
    OUTISDE_GLASS: 'Utvändigt glas',
    NO_NCS_INFO: 'Den angivna NCS koden hittades inte. Vänligen prova en annan NCS kod.',
    PRODUCT_LOOK_INFO: 'Produktbilden är bara en exempelbild och kan vara extra utrustad.',
    NCS_INFO: 'Ange önskad kulörkod.',
    SET_DEFAULT_COLOR: 'Ange standard kulör',
    ANGLE: 'Vinkel',
    PRODUCT_NOT_AVAILABLE: 'Utgått ur sortimentet, vänligen välj annan serie',
    CALCULATE_PRICE_LINK: 'Beräkna din frakt här',
    MULLION_TYPES: 'Modell',
    SMOOTH: 'Slät',
    DECOR: 'Dekor',
    BAR_TYPE: 'Typ',
    FOLD_ON: 'Viks åt',
    COLOR_WARNING: 'Kulören som visas på skärmen kan vara något avvikande från verkligheten',
    DOOR_INSIDE_OUTSIDE_COLOR_INFO: 'Det går endast att välja samma kulör på in och utsida, eller standard vit inisda och valfri kulör utsida',
    FLASHING: 'Intäckningsplåtar',
    ADDITIONAL_ACCESSORIES: 'Tillval',
    INCLUDED_ACCESSORIES: 'Ingår',
    WIDTH_DIMENSION_INFO: 'Dimensioner för bredd: ',
    HEIGHT_DIMENSION_INFO: 'Dimensioner för höjd: ',
    DIMENSIONS_CONTACT_INFO: 'Ring oss om du har några frågor: 0431-37 14 00.',
    GO_TO_PRODUCT: 'Gå till produkt',
    TILL: 'Tom',
    U_VALUE: 'U-värde',
    READ_MORE_ABOUT_THIS_SERIE: 'Läs mer om denna serie',
    SHAPE_HEADER: 'Välj form',
    WARM: 'Varmkantlist',
    ALUMINIUM: 'Aluminium',
    GLAZING_SPACERS: 'Glaskantlister',
    GLAZING_SPACER_COLOR_CHANGE_INFO: 'När du ändrar kulör ändras även kulören på varmkantlisten. Se under fliken Glaskassett.',
    HANDLE_INSIDE: 'Invändig handtag',
    HANDLE_OUTSIDE: 'Utvändig handtag',
    BE_CREATIVE: 'Var kreativ',
    STOCK_ITEM: 'Lagervara',
    FAST_DELIVERY: 'Snabb leverans',
    COLOR_RULE_NOTICE: 'När produkten överstiger dimensionerna 4862x2600mm kan vi inte erbjuda mörka kulörer på grund av expansionsrisken vid varmt väder och solljus.',
    DIMENSION_RULE_NOTICE: 'Du har valt en mörk kulör som inte går att få i det valda måttet. Maximala mått är 4862x2600mm på grund av expansionsrisk vid varmt väder eller solljus.',
    DEFAULT_CONFIGURATIONS: 'Förvalda förslag',
    DESIGN_YOURSELF: 'Designa själv',
    EXTERNAL_MUNTIN: 'Utanpåliggande spröjs',
    MIDDLEGLASS_MUNTIN: 'Mellanglasspröjs',
    IN_OUT_DUPLEX_MUNTIN: 'Wienerspröjs',
    DESIGN_YOURSELF_DESCRIPTION_HEADER: 'Skapa din egen design med spröjs och mittpost',
    DESIGN_YOURSELF_DESCRIPTION: 'Välj om det är mittpost eller spröjs du önskar använda. Man kan självklart kombinera mittpost och spröjs genom att gå in på respektive kategori.',
    MUNTINS_DESCRIPTION: 'Alla spröjs är utanpåliggande löstagbara spröjs. Vid val av aluminium är spröjsen helt i aluminium och har samma kulör på båda sidor av spröjsen som produktens utvändiga kulör. Denna typ av spröjs går ej att få tvåfärgsmålad. För andra lösningar eller material se "Designa själv". Observera att diagonala spröjs enbart går att göra som mellanglasspröjs.',
    MULLIONS_DESCRIPTION: 'Mittpost är glasdelande och med slät insida. Mittposten målas i samma kulör som övrig konstruktion.',
    CLOSE: 'Stäng',
    MUNTIN_CHANGE_INFO: 'Vid ändring av kulör ändras även kulören på mittposten. Se i menyn under Spröjs & Mittpost.',
    MUNTIN_DIDNT_CHANGE_INFO: 'Vi kunde tyvärr inte hitta rätt match av kulör till dina spröjs. Vänligen välj passande kulör manuellt under fliken Spröjs & Mittpost.',
    READ_MORE: 'Läs mer',
    REGULAR_PRICE: 'Konsumentpris',
    NORMAL_PRICE: 'Senast lägsta pris',
    INCLUDING_TAX: 'inkl. moms',
    EXCLUDING_TAX: 'exkl. moms',
    VISUALIZATION_NOTICE: 'Ritningen är inte skalenlig och endast ett exempel på hur det kan komma att se ut.',
    GLAZING_RULE_NOTICE: "Kombinationen av de glastyper som är valt är tyvärr inte möjlig. Vänligen välj en annan kombination eller kontakta oss för hjälp 0431-37 14 00.",
    DIAGONAL_SETUP_RULE_NOTIFICATION: "Du har valt en förvald spröjskonfiguration som innehåller diagonala spröjs. Endast mellanglasspröjs är möjligt i den spröjskonfigurationen du valt.",
    ORNAMENT_GLASS_RULE_NOTICE: "Det är inte möjligt att kombinera säkerhetsglas på insidan med ornament på insidan. Vänligen välj ett av alternativen.",
    GO_TO_CART: "Gå till kassan",
    PRODUCTS_ADDED_TO_SHOPPING_CART: "PRODUKTER ÄR TILLAGDA I DIN VARUKORG",
    ADD_TO_CART_AND_CONTINUE: "Lägg i varukorg och fortsätt handla",
    RECOMMEND_ADDING_ACCESSORIES: "Vi rekommenderar att lägga till följande tillval",
    CONTROL_SIDE: 'Reglagets placering',
    BOX: 'Profil',
    FABRIC: 'Tyg & Färg',
    TOP_LATH: 'Profil',
    LOUVRE: 'Lameller',
    BOTTOM_RAIL: 'Nedre handtag',
    LATH: 'Profil',
    SHEATING: 'Material & Färg',
    MONTAGE_TYPE: 'Typ av montage',
    DRIVE: 'Styrning',
    STACKING_TYPE: 'Schema',
    TOP_RAIL: 'Profil',
    CHAIN: 'Kedja',
    BASEMENT_WINDOW_RULE_NOTICE: "Det går endast att få haspar på det angivna måttet. Om ni önskar få handtag vänligen öka storleken.",
    MAX_DIMENSIONS_NOTICE: "Dimensionerna justerades på grund av att det inte går att lägga till färg på den valda dimensionen.",
    CONTACT_US_FOR_PRICE: "Kontakta oss för pris",
    CART_URL: 'kassa',
    CART_PAYMENT_INFO: 'Betala direkt, senare eller dela upp med Svea.',
    CLICK_HERE: 'klicka här',
    JUMP_TO_CONFIGURATOR_LABEL: 'Vill du konfigurera din produkt gör du det enkelt genom att',
};
